module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"review_button_title":"レビュー詳細ポップアップを開く"}}')
  delete Component.options._Ctor
}
